import { render, staticRenderFns } from "./mandatoryInfo.vue?vue&type=template&id=320cc7a4&scoped=true&"
import script from "./mandatoryInfo.vue?vue&type=script&lang=js&"
export * from "./mandatoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./mandatoryInfo.vue?vue&type=style&index=0&id=320cc7a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320cc7a4",
  null
  
)

export default component.exports